"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountPreview = exports.PreviewController = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var Preview_1 = require("./Preview");
var HubspotShareOverlay_1 = require("Hubspot/Share/HubspotShareOverlay");
var HeroinTypes_1 = require("@CommonFrontend/Utils/HeroinTypes");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var Util_1 = require("@CommonFrontendBackend/Permissions/Util");
var Types_2 = require("@CommonFrontendBackend/Projects/Types");
var PreviewController = (function (_super) {
    __extends(PreviewController, _super);
    function PreviewController(props) {
        var _this = _super.call(this, props) || this;
        _this.shareProject = function () {
            (0, HubspotShareOverlay_1.showHubspotShareOverlay)(_this.props.project, _this.di);
        };
        _this.deleteProject = function () { return __awaiter(_this, void 0, Promise, function () {
            var shouldDelete, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.projectService.confirmDelete(this.props.project)];
                    case 1:
                        shouldDelete = _a.sent();
                        if (!shouldDelete) return [3, 3];
                        return [4, this.props.projectService.delete(this.props.project)];
                    case 2:
                        response = _a.sent();
                        if (response === null || response === void 0 ? void 0 : response.success) {
                            this.donePreviewing();
                        }
                        else if (response === null || response === void 0 ? void 0 : response.message) {
                            this.props.notifyUser.error(response.message);
                        }
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        }); };
        _this.donePreviewing = function () {
            window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
        };
        _this.isEditable = function () {
            var project = _this.props.project;
            return (0, Util_1.isAtLeast)(project.userAction, Types_1.Action.Edit) && (0, Utils_1.isActionAllowed)(project.status, Types_2.ProjectActions.Edit);
        };
        _this.buildPreviewUrl = function () {
            var _a = _this.props, pageProtocol = _a.pageProtocol, genericHost = _a.genericHost, project = _a.project;
            return "".concat(pageProtocol, "://").concat(genericHost, "/").concat(project.links[0].secret);
        };
        _this.buildEditUrl = function () {
            if (_this.isEditable()) {
                var _a = _this.props, clientUrl = _a.clientUrl, project = _a.project;
                return "".concat(clientUrl, "/#/project/").concat(project._id, "?loginType=hubspot");
            }
            else {
                return "";
            }
        };
        return _this;
    }
    PreviewController.prototype.componentDidMount = function () {
        switch (this.props.previewAction) {
            case "share":
                this.shareProject();
                break;
            case "delete":
                this.deleteProject();
                break;
        }
    };
    PreviewController.prototype.render = function () {
        var project = this.props.project;
        return (react_1.default.createElement(Preview_1.Preview, { projectName: project.name, previewUrl: this.buildPreviewUrl(), isEditable: this.isEditable(), editUrl: this.buildEditUrl(), shareProject: this.shareProject, done: this.donePreviewing }));
    };
    var _a;
    __decorate([
        (0, inversify_react_1.resolve)("di"),
        __metadata("design:type", typeof (_a = typeof HeroinTypes_1.IHeroin !== "undefined" && HeroinTypes_1.IHeroin) === "function" ? _a : Object)
    ], PreviewController.prototype, "di", void 0);
    PreviewController = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PreviewController);
    return PreviewController;
}(react_1.default.Component));
exports.PreviewController = PreviewController;
var mountPreview = function (mountReactComponent, notifyUser, projectService, project, user, genericHost, pageProtocol, clientUrl, previewAction) {
    return mountReactComponent(react_1.default.createElement(PreviewController, { project: project, user: user, projectService: projectService, notifyUser: notifyUser, previewAction: previewAction, genericHost: genericHost, pageProtocol: pageProtocol, clientUrl: clientUrl }));
};
exports.mountPreview = mountPreview;
